import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

// When a dropdown uses `container="body"`, ng-bootstrap moves the menu into a
// wrapper <div> appended to <body> with a hard-coded `z-index: 1055`
// (see NgbDropdown._applyContainer). A popover defaults to z-index 1070, so a
// dropdown opened inside a popover (e.g. the chat popover) renders *behind* it.
//
// The dropdown's host element (`_nativeElement`) stays in place inside the
// popover, so we inspect the layer it was opened from: we read the highest
// z-index among its ancestors and lift the menu wrapper just above it. This is
// dynamic and contextual - with nothing stacked above the wrapper (no popover,
// or a low-z-index ancestor) ng-bootstrap's default 1055 is left untouched.
export function installDropdownPopoverZIndexPatch() {
    const prototype = NgbDropdown.prototype as any;
    const original_apply_container = prototype._applyContainer;

    prototype._applyContainer = function (container: 'body' | null = null) {
        original_apply_container.call(this, container);

        const body_container = this._bodyContainer as HTMLElement | null;
        const host: HTMLElement | undefined = this._nativeElement;
        if (container !== 'body' || !body_container || !host) return;

        const base_z_index = parseInt(body_container.style.zIndex || '1055', 10);

        // Highest z-index of the layer the dropdown was opened from.
        let surrounding_z_index = 0;
        let ancestor = host.parentElement;
        while (ancestor) {
            const z_index = parseInt(getComputedStyle(ancestor).zIndex, 10);
            if (!Number.isNaN(z_index)) {
                surrounding_z_index = Math.max(surrounding_z_index, z_index);
            }
            ancestor = ancestor.parentElement;
        }

        if (surrounding_z_index >= base_z_index) {
            body_container.style.zIndex = String(surrounding_z_index + 1);
        }
    };
}
